import { useEffect } from "react";
import {ReactComponent as CloseIcon} from '../../assets/icons/closeIcon.svg'

export const Modal = ({
    isOpen,
    onClose,
    children,
    title,
    closeOnOverlayClick = true,
    isCloseButtonOnTop = false,
    borderRadius,
    contentStyle,
    footer
  }) => {
    // Обработчик нажатия ESC
    useEffect(() => {
      const handleKeyDown = (e) => {
        if (e.key === 'Escape') onClose();
      };
  
      if (isOpen) {
        window.addEventListener('keydown', handleKeyDown);
      }
  
      return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);
  
    if (!isOpen) return null;
  
    return (
      <div
        className="modal-overlay"
        onClick={closeOnOverlayClick ? (e) => {
          // Закрываем только при клике на оверлей
          if (e.target === e.currentTarget) onClose();
        } : undefined}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <div
          className="modal-content"
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: borderRadius ? '8px' : 0,
            minWidth: '300px',
            maxWidth: contentStyle?.maxWidth ? contentStyle.maxWidth : '90%',
            position: 'relative',
            boxSizing: 'border-box',
            width: contentStyle?.width ? contentStyle.width : 'auto',
            height: contentStyle?.height ? contentStyle.height : 'auto',
            overflow: contentStyle?.overflow ? contentStyle.overflow : 'hidden',
            padding: contentStyle?.padding ? contentStyle.padding : '20px',
          }}
        >
          {/* Заголовок и кнопка закрытия */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
          }}>
            <div style={{ margin: 0 }}>{title}</div>
            {isCloseButtonOnTop && <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1.5rem',
                padding: '0 5px',
                color:'black'
              }}
            >
              <CloseIcon/>
            </button>}
          </div>
  
          {/* Основное содержимое модалки */}
          <div>{children}</div>
            {footer && <div >{footer}</div>}
        </div>
      </div>
    );
  };